import React from 'react';

export type SettingsSaveStatus = 'idle' | 'saving' | 'saved' | 'error';

interface SettingsSaveButtonProps {
  status: SettingsSaveStatus;
  onClick: () => void;
  disabled?: boolean;
  idleLabel?: string;
}

export const SettingsSaveButton: React.FC<SettingsSaveButtonProps> = ({
  status,
  onClick,
  disabled,
  idleLabel = 'Save changes',
}) => (
  <div className="kx-settings-save">
    <button
      type="button"
      className={`kx-settings-save__btn kx-settings-save__btn--${status}`}
      onClick={onClick}
      disabled={disabled || status === 'saving'}
    >
      {status === 'saving' && 'Saving…'}
      {status === 'saved' && '✓ Saved'}
      {status === 'error' && '✗ Try again'}
      {status === 'idle' && idleLabel}
    </button>
  </div>
);

export default SettingsSaveButton;
